import axios from "axios";

const API = axios.create({
  baseURL: "https://api.getcoredispatch.cloud",
});

export default API;